module.exports = __webpack_public_path__ + "media/feedback-3-cecce054178f8adf8517de80108f99b6.gif";